import { useContext } from "react";

import ArtworkDataContext from "@/context/ArtworkDataContext";

import {
  TEMPLATE_DESIGNS,
  TEMPLATE_FORMATS,
  TEMPLATE_MODE_PALETTE,
} from "../constants";

import "./styles/TemplatePreview.css";

const DEFAULT_TEXT = {
  artist: "Artist Name",
  title: "Artwork Title",
};

const TemplatePreview = ({
  reference,
  croppedUrl,
  design,
  format,
  mode,
  originalImage,
  artworkData: artworkDataProp,
}) => {
  const context = useContext(ArtworkDataContext);
  const artworkData = artworkDataProp || context?.artworkData;

  if (!design || !format) {
    return null;
  }

  const palette = TEMPLATE_MODE_PALETTE[mode] || TEMPLATE_MODE_PALETTE.dark;

  const artworkAbout = artworkData?.artwork_about ?? {};
  const artist = artworkAbout.artwork_gallery_artist ?? {};

  const artistName = artist.artist_name || DEFAULT_TEXT.artist;
  const artworkTitle = artworkAbout.artwork_title || DEFAULT_TEXT.title;

  const imageSource =
    design === TEMPLATE_DESIGNS.TYPE_ONE
      ? croppedUrl || originalImage
      : originalImage || croppedUrl;

  const safeFormat = format || TEMPLATE_FORMATS.STORY;

  return (
    <div
      ref={reference}
      className={`template-preview template-preview--${design} template-preview--${safeFormat}`}
      data-mode={mode}
      style={{
        "--template-background": palette.background,
        "--template-contrast": palette.contrast,
        "--template-neutral": palette.neutral,
      }}
    >
      {design === TEMPLATE_DESIGNS.TYPE_ONE && (
        <div className={`template-preview__type-one ${safeFormat}`}>
          <div className="template-preview__type-one-info">
            <span className="template-preview__type-one-artist">{artistName}</span>
            <span className="template-preview__type-one-title">{artworkTitle}</span>
            <span className="template-preview__type-one-cta">See full at Suarte</span>
          </div>

          <div className="template-preview__type-one-image">
            {imageSource && (
              <img src={imageSource} alt="Artwork preview" />
            )}
          </div>
        </div>
      )}

      {design === TEMPLATE_DESIGNS.TYPE_TWO && (
        <div className="template-preview__type-two">
          <div
            className="template-preview__type-two-blur"
            style={{ backgroundImage: `url(${imageSource || ""})` }}
          />
          <div className="template-preview__type-two-overlay">
            <div className="template-preview__type-two-content">
              <div className="template-preview__type-two-text">
                <span className="template-preview__heading">{artistName}</span>
                <span className="template-preview__title">{artworkTitle}</span>
              </div>
              <div className="template-preview__type-two-image">
                {imageSource && (
                  <img src={imageSource} alt="Artwork preview" />
                )}
              </div>
              <span className="template-preview__type-two-cta">Available at Suarte</span>
            </div>
          </div>
        </div>
      )}

      {design === TEMPLATE_DESIGNS.TYPE_THREE && (
        <div className="template-preview__type-three">
          <div className="template-preview__type-three-content">
            <div className="template-preview__type-three-text">
              <span className="template-preview__heading">{artistName}</span>
              <span className="template-preview__title">{artworkTitle}</span>
            </div>
            <div className="template-preview__type-three-image">
              {imageSource && (
                <img src={imageSource} alt="Artwork preview" />
              )}
            </div>
            <span className="template-preview__type-three-cta">Available at Suarte</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default TemplatePreview;
